import React from 'react';

export default class PopupWithoutUseClickOutside extends React.Component {
	render() {
		if (this.props.isPopupVisible) {
			return (
				<div className="popup">
					<div className="popup-inner" style={this.props.style}>
						{this.props.children} 
					</div>
				</div>
			);
		}
		return null;
	}
}
